import React from 'react';
import dynamic from 'next/dynamic';
import { RankIcon } from '@/assets/icons';
import Image from 'next/image';
const AnimatedNumbers = dynamic(() => import('react-animated-numbers'), {
  ssr: false,
});

const NumberCounting = () => {
  return (
    <div className="w-full py-16 md:py-[84px] relative ">
      <Image
        src={'https://images.fineartamerica.com/images-medium-large-5/egg-factory-jean-michel-labat.jpg'}
        alt="Nền thống kê thành tích - Trường Thọ Food"
        fill
        className="object-cover object-center"
      />
      <div className="absolute w-full h-full inset-0 bg-black bg-opacity-50" />
      <div className="container z-20 relative grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-8">
        <div className="flex flex-col gap-2 md:gap-4 items-center text-white">
          <RankIcon />
          <p className="flex items-baseline gap-1 text-[24px] md:text-[32px] font-bold">
            <AnimatedNumbers
              animateToNumber={16}
              transitions={index => ({
                type: 'spring',
                duration: index + 0.3,
              })}
            />
            <span>Năm</span>
          </p>
          <p className="text-center text-[16px] md:text-[20px] font-semibold">
           Kinh nghiệm trong ngành
          </p>
        </div>
        <div className="flex flex-col gap-2 md:gap-4 items-center text-white">
          <RankIcon />
          <p className="flex items-baseline gap-1 text-[24px] md:text-[32px] font-bold">
            <AnimatedNumbers
              animateToNumber={2}
              transitions={index => ({
                type: 'spring',
                duration: index + 1.3,
              })}
            />
            <span>Triệu</span>
          </p>
          <p className="text-center text-[16px] md:text-[20px] font-semibold">
            Trứng được giao mỗi tháng
          </p>
        </div>
        <div className="flex flex-col gap-2 md:gap-4 items-center text-white">
          <RankIcon />
          <p className="flex items-baseline gap-1 text-[24px] md:text-[32px] font-bold">
            <AnimatedNumbers
              animateToNumber={100}
              transitions={index => ({
                type: 'spring',
                duration: index + 0.5,
              })}
            />
            <span>+</span>
          </p>
          <p className="text-center text-[16px] md:text-[20px] font-semibold">
            Đối tác trên toàn quốc
          </p>
        </div>
        <div className="flex flex-col gap-2 md:gap-4 items-center text-white">
          <RankIcon />
          <p className="flex items-baseline gap-1 text-[24px] md:text-[32px] font-bold">
            <AnimatedNumbers
              animateToNumber={50}
              transitions={index => ({
                type: 'spring',
                duration: index + 1,
              })}
            />
            <span>+</span>
          </p>
          <p className="text-center text-[16px] md:text-[20px] font-semibold">
            Trang trại khu vực miền Nam
          </p>
        </div>
      </div>
    </div>
  );
};

export default NumberCounting;
